/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface GetFormulesByFormuleidImage$Params {
  FormuleId: number;
}

export function getFormulesByFormuleidImage(
  http: HttpClient,
  rootUrl: string,
  params: GetFormulesByFormuleidImage$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, getFormulesByFormuleidImage.PATH, 'get');
  if (params) {
    rb.path('FormuleId', params.FormuleId, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    }),
  );
}

getFormulesByFormuleidImage.PATH = '/Restaurants/formules/{FormuleId}/image';
